import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import {NotificationsService} from "angular2-notifications";
import {Router} from "@angular/router";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
errorObj = {
        name: '',
        target: '',
        phone: '',
        password: '',
        passwordrepeat: '',
        group: '',
        gender: '',
        confirmpassword: '',  
        phonecode:'',
        eurbalance:'',
    };
    passclass = 'bar';
  constructor(private userService:UserService,
              private notifSer:NotificationsService,
              private router:Router) { }
    resetPassword = {
    password: '',
    confirmpassword:'',
    authflag: true,
    _csrf: null,
    otpcodeData:'',
    target: '',
  };
  submit:boolean;
  ngOnInit() {
    this.csrf();
  }
  csrf() {
    this.userService.csrf().subscribe((response) => {
        // console.log(response)
        this.resetPassword._csrf = response._csrf;
    }, (err) => {
        this.notifSer.error(
            'Error CSRF',
            err.error.message,
            {
                timeOut: 3000,
                showProgressBar: true,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
            }
        )
    });
  }
  cancel(){
    // this.router.navigate(['forgot-password'])
    this.router.navigateByUrl('/forgot-password');
  }
   clearError(field) {
        switch (field) {
            case 'name':
                this.errorObj.name = '';
                break;
            case 'target':
                this.errorObj.target = '';
                break;
            case 'password':
                this.errorObj.password = '';
                break;
            case 'confirmpassword':
                this.errorObj.confirmpassword = '';
                break;
        }
    }
   checkpassword(val, flag) {
    // console.log(val,'dd')
        var strongRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$", "g");
        // var mediumRegex = new RegExp("((^)(^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{6,}$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$|^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$))+$", "g");
        // if (this.MatchPassName(this.userobj.name, val)) {
        //     this.errorObj.password = "Do not use name in password";
        // } else {
        //     this.clearError('name');
        //     this.clearError('password');
        // }
        // console.log(this.userobj.password)
        // if (this.MatchPassName(this.forgetpassObj.name, val)) {
        //     this.errorObj.password = "Do not use name in password";
        // }
        // if (/\s/.test(val)) {
        // //    console.log("It has any kind of whitespace") 
        //    this.errorObj.password = 'Do not use whitespace';
        // }
        if (this.resetPassword.password === '') {
          console.log('empty');
          
          this.clearError('password');
        }
        else if (/\s/.test(val)) {
          
          this.errorObj.password = 'Do not use whitespace';
          
        }
           else if(strongRegex.test(val)){
              // this.errorObj.password = 'Password is Strong';
            }
        // else if (strongRegex.test(val)) {
        //     this.passclass = 'strong';
        //     this.errorObj.password = 'Password is Strong';
        //   console.log('strong',val);
          
        // } 
        else {
            this.passclass = 'weakasa';
            this.errorObj.password = 'Password is Weak';
        }
            
        
    }
  Reset(){
  this.submit=true;

    if(JSON.stringify(this.resetPassword).search('""') !=-1){
      return false
    }else{
      var strongRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$", "g");
      // var mediumRegex = new RegExp("((^)(^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{6,}$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$|^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$))+$", "g");
     
      console.log(this.resetPassword);
      var spacestatus = /\s/.test(this.resetPassword.password);
      if(strongRegex.test(this.resetPassword.password) && !spacestatus && this.resetPassword.password==this.resetPassword.confirmpassword){
        this.userService.resetPassword(this.resetPassword).subscribe((response) => {
          this.notifSer.success(
            'Success',
            'password changed successfully',
            {
                timeOut: 5000,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                maxLength: 50
            }
        )
            setTimeout(() => {
              this.router.navigateByUrl('/index');
            }, 1000)
  
        }, (err) => {
          this.notifSer.error(
            'Error',
            err.error.message,
            {
                timeOut: 5000,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                maxLength: 50
            }
        )
        });
      }



    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts